// ! Copyright (c) 2024, Brandon Ramirez, brr.dev

import { PortfolioProjectEntry } from './ProjectCards.types';
import ProjectCard from './ProjectCard';
import './ProjectCards.scss';
import { Contentful } from '@brr-dev/contentful';

export type ProjectCardsProps = {
    projects?: PortfolioProjectEntry[];
    assets: Record<string, Contentful.Asset>;
};

export default function ProjectCards({ projects, assets }: ProjectCardsProps) {
    return !projects ? null : (
        <div className="project-cards-container">
            {projects.map((project) => {
                const coverImage = assets[project.fields.coverImage.sys.id] ?? false;
                return <ProjectCard project={project} coverImage={coverImage} />;
            })}
        </div>
    );
}
